<template>
  <page>
    <template slot="content">
    <help-content :title="'ﾍﾙｽｹｱに切替えたら歩数がﾍﾙｽｹｱｱﾌﾟﾘより少ない'">
      <template slot="content">
        <div class="text">
          不正防止のため、WeRUNでは、<b>計測方法に指定された一つのデバイスのみ</b>がWeRUNの歩数をアップデートできます。<br><br>
          ヘルスケアに設定した場合、ヘルスケアアプリの<b>データソースとアクセス＞データソースリストの一番上のデバイスのみ</b>が歩数をアップデートできます。例えば、スマホとApple Watch（リストの一番上）を同時に持ち歩いた場合、Apple Watchのみが歩数をアップデートできます。<br><br>
          一方、ヘルスケアアプリでは複数のデータソースが歩数をアップデートできるようになっているため、スマホとApple Watch（リストの一番上）を同時に持ち歩いた場合、両方のデバイスが歩数を更新することがあります。これによって、WeRUNの歩数より多く表示されています。<br><br>
          <b>歩数が正しく計測できるように、指定した計測方法のデバイスを常に身に着けて歩くことをおすすめします。</b>
        </div>
        <div class="text">※ヘルスケアアプリの歩数データ（複数デバイスで計測しているケース）</div>
        <img class="picture" src="../assets/images/q_and_a/H41.png">
      </template>
    </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help41.vue